import React, { useEffect, useState } from 'react';
import { ClickAwayListener } from '@mui/material';
import {
  DataGrid,
  GridRowParams,
  GridRowSpacingParams,
  useGridApiRef,
} from '@mui/x-data-grid';

import { CustomNoRowsOverlay, CustomPagination } from './components/common';

interface TableProps {
  rows: any;
  columns: any;
  loading?: boolean;
  shouldShowOnlyHeader?: boolean;
  shouldShowOnlyContent?: boolean;
  onRowClick: (params: any) => void;
}

export const Table = ({
  rows,
  columns,
  loading,
  onRowClick,
  shouldShowOnlyHeader = false,
  shouldShowOnlyContent = false,
}: TableProps) => {

  const apiRef = useGridApiRef();

  const getRowSpacing = React.useCallback((params: GridRowSpacingParams) => {
    return {
      top: params.isFirstVisible ? 16 : 8,
      bottom: params.isLastVisible ? 16 : 8,
    };
  }, []);

  return (
    <ClickAwayListener onClickAway={() => apiRef?.current?.setRowSelectionModel([])}>
      <DataGrid
        getRowSpacing={getRowSpacing}
        pagination
        hideFooter={rows.length === 0 || shouldShowOnlyContent}
        apiRef={apiRef}
        rows={rows}
        columns={columns}
        disableColumnFilter
        disableColumnMenu
        disableDensitySelector
        disableVirtualization
        rowHeight={48}
        columnHeaderHeight={48}
        onRowClick={onRowClick}
        loading={loading}
        initialState={{
          pagination: {
            paginationModel: { pageSize: 10, page: 0 },
          },
        }}
        slots={{
          columnResizeIcon: () => null,
          pagination: CustomPagination,
          noRowsOverlay: shouldShowOnlyHeader ? () => null : CustomNoRowsOverlay,
        }}
        sx={{
          '&, [class^=MuiDataGrid]': {
            border: 'none',
          },
          '& .MuiDataGrid-columnHeaders': {
            display: shouldShowOnlyContent ? 'none' : 'block',
          },
          '& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within': {
            outline: 'none'
          },
          '& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within': {
            outline: 'none',
          },
          '& .MuiDataGrid-cell, & .MuiDataGrid-columnHeader': {
            cursor: 'default'
          },
          '& .MuiDataGrid-columnHeader': {
            backgroundColor: '#FAFAFA',
          },
          '& .MuiDataGrid-columnHeaderTitle': {
            textTransform: 'uppercase',
            color: '#828282',
            fontSize: '14px',
            fontWeight: '400'
          },
          '& .MuiDataGrid-row:hover': {
            backgroundColor: '#FFF8FA'
          },
          '& .MuiDataGrid-virtualScroller': {
            height: rows.length === 0 ? shouldShowOnlyHeader ? '0px' : '56px' : undefined,
          },
          '& .MuiDataGrid-selectedRowCount': {
            visibility: 'hidden',
          },
          '& .MuiDataGrid-row:first-child': {
            marginTop: shouldShowOnlyContent ? '8px !important' : '16px',
          },
        }}
      />
    </ClickAwayListener>
  )
}
